import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '@/store'
import loading from '@/plugins/loading'
import snapshot from '@/plugins/snapshot'
import get from 'lodash-es/get'

const DEFAULT_PAGE_TITLE = 'LMS Manager'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  const goodToGo = snapshot.validate() || window.confirm('Changed you made have not been saved. Are you sure to leave?')
  if (to.meta && to.meta.hasOwnProperty('permission')) {
    const policies = store.state.auth.policies
    if (!policies[to.meta.permission]) {
      const role = store.state.auth.role
      if (role.type !== 'teacher') next('/dashboard')
      else next('/teacher-dashboard')
    } else next(goodToGo && _authGuard(to))
  } else {
    next(goodToGo && _authGuard(to))
  }
})

const getMetaMainTitle = (category = '') => {
  switch (category) {
    case 'main':
      return 'Thành phần lương'
    case 'adjust':
      return 'Điều chỉnh lương'
    case 'sub-minus':
      return 'Khoản truy thu'
    case 'sub-sum':
      return 'Khoản hoàn trả'
    default:
      return ''
  }
}

const getMetaTitleForSalaryHeadRoutes = (category = '', isDetail = false) => {
  const mainTitle = getMetaMainTitle(category)
  return isDetail ? 'Chi tiết ' + mainTitle : mainTitle
}

router.afterEach(to => {
  if (to.fullPath.includes('salary-head')) {
    to.meta.title = getMetaTitleForSalaryHeadRoutes(to.params.category, !!to.params.id)
  }
  _setDocumentTitle(to.meta.title)
  _resetPlugins()
})

function _setDocumentTitle(title = DEFAULT_PAGE_TITLE) {
  document.title = title
}

function _resetPlugins() {
  loading.hide()
  snapshot.reset()
}

function _authGuard(to) {
  if (!to.name) return '/dashboard'

  if (!to.name || to.name === 'dashboard') {
    let lmsStorage = JSON.parse(localStorage.getItem('lms'))
    if (get(lmsStorage, 'auth.user.role.type') === 'teacher') return '/teacher-dashboard'
  }

  let hasAuthRule = false
  let requriedAuth = false
  const { isAuthenticated } = store.state.auth

  for (let route of to.matched) {
    if (!route.meta.hasOwnProperty('auth')) {
      continue
    }
    hasAuthRule = true
    if (route.meta.auth) {
      requriedAuth = true
      break
    }
  }

  if (hasAuthRule) {
    if (requriedAuth) {
      if (isAuthenticated) return true
      return '/signin'
    }
    if (isAuthenticated && to.name !== 'resetPassword') return '/dashboard'
  }
  return true
}

window.onbeforeunload = () => {
  if (!snapshot.validate()) return true
}

export default router
